export default __webpack_public_path__ + "static/media/icon_2_0.4f309c5c.svg";